import {
  Dashboardv20240509Api,
  dashboardv20240509Client
} from '@sequencehq/api/dashboard/v20240509'
import { useCallback } from 'react'

export type v1ApiTaxRate = Dashboardv20240509Api.GetTaxRate.TaxRate
type UseLoadSingleTaxRate = () => (props: {
  taxRateId: string
}) => Promise<v1ApiTaxRate | null>

export const useLoadSingleTaxRate: UseLoadSingleTaxRate = () => {
  const load = useCallback(async ({ taxRateId }: { taxRateId: string }) => {
    const taxRate = (
      await dashboardv20240509Client.getTaxRate({ id: taxRateId })
    )?.data

    return taxRate
  }, [])

  return load
}
